import React from "react";

function InstructionsComp(props) {
   const { closeModal } = props;
   return (
      <div className="instructions-container">
         <div className="bg-white flex-center flex-column position-relative p-4" style={{ borderRadius: "5px" }}>
            <div className="text-xlarge text-primary2 text-bold d-flex w-100 flex-center">
               Instructions
               <div className="position-absolute" style={{ right: "10px", top: "0px" }}>
                  <button onClick={closeModal}>&times;</button>
               </div>
            </div>
            <div className="flex-center flex-column text-medium text-black4">
               <div className="my-3 w-95">
                  {"Here is an overview of how to allow permissions for your microphone and screen sharing:"}
               </div>
               <ol className="ol-list-decimal w-85">
                  <li>{"Open the settings of your device or browser."}</li>
                  <li>
                     {
                        "Navigate to the section related to permissions or privacy settings. This section usually allows you to configure which apps or websites can access specific features of your device or browser."
                     }
                  </li>
                  <li>{"Find the options related to microphone and screen sharing."}</li>
                  <li>{"Toggle the switch to allow or grant access to the microphone and screen sharing."}</li>
                  <li>
                     {
                        "Some platforms or apps may prompt you to confirm the decision to allow permissions. In this case, confirm by clicking the “Allow” button or a similar option."
                     }
                  </li>
                  <li>
                     {
                        "Once you have granted permission for the microphone and screen sharing, the app or website should be able to access these features."
                     }
                  </li>
               </ol>
               <div className="my-3 w-95">
                  {
                     "Note: The process to allow permissions may vary depending on the platform or application you are using. However, most platforms and applications will have similar settings where you can configure permissions for the microphone and screen sharing."
                  }
               </div>
            </div>

            <div className="w-90 flex-center my-4">
               <button className="btn-default text-small h-xsmall w-50 round-border-s" onClick={closeModal}>
                  {"Done"}
               </button>
            </div>
         </div>
      </div>
   );
}

export default InstructionsComp;
